/** @format */

import React, { useEffect, useState } from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import { PageContainer, StepperKeeperOld, ButtonLoading, ConfirmDialog } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { useStyles } from './style';
import { useNavigate, useLocation } from 'react-router-dom';
import { enifyDateTime, getDynamicObjectAction, constBreadCrumbsTitle, getQuery  } from 'utility';
import jMoment from 'moment-jalaali';
import { useQuery } from 'hooks';
import CreateDiscountServices from './services/CreateDiscountServices';
import { BaseInfo, Overview, GeneratedCodes } from './components';
import { MessageCartableDg } from 'components';
import useCustomHook from './hooks';
import createToast from 'components/Toast/Toast';
import { useCurrencyUnit} from 'hooks';

const CreateDiscount = () => {
  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList =
    getDynamicObjectAction([
      'AddCreditVouchersBtn',
      'AddCreditVouchersSecoundBtn',
      'AddCreditVouchersPage',
      'creditVoucherList'

    ]);

  const defaultValues = {
    name: '', // [String]
    guildCode: '', // String
    wallet: '',
    description: '', // [String]
    amount: null, // [Float]
    count: '', // [Int]
    expireDate: jMoment(new Date()).add(10, 'days'), // String
    currencyCode: 'IRR',
    limitedConsumerId: null, // Int
  };
 const currencyText = useCurrencyUnit(false);

  // -- STATE --//
  const query = useQuery();
  const {
    isConfirmOpen,
    setIsConfirmOpen,
    isFromWallet,
    setIsFromWallet,
    generatedVouchers,
    setGeneratedVouchers,
    dataToExport,
    setDataToExport,
    titlesToExport,
    setTitlesToExport,
    totalCount,
    setTotalCount,
    targetUser,
    setTargetUser,
    loading,
    setLoading,
    activeStep,
    setActiveStep,
    isOpenMessageCartableDg,
    setIsOpenMessageCartableDg,
    requestId,
    setRequestId
  } = useCustomHook();

  // -- HOOKS --//
  const navigate = useNavigate();
  const methods = useForm({ defaultValues });
  const { handleSubmit, formState: { errors } } = methods;
  const classes = useStyles();
  const location = useLocation();
  const [urlQuery, setUrlQuery] = useState(null);

  useEffect(() => {
    let result = getQuery(location);
    setUrlQuery(result)
  }, [location]);


  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setIsConfirmOpen(false);
    }
  }, [errors]);
  useEffect(() => {// زماینکه دیالوگ اطلاع رسانی نوع کارتابلی بسته شود ، ریکوعست آیدی خالی میشود
    !isOpenMessageCartableDg && setRequestId(null);
  }, [isOpenMessageCartableDg])

  useEffect(() => {
    if (query) {
      const tUser = {
        userId: query.get('id') ? query.get('id') : query.get('userId'),
        fullName: query.get('fullName'),
        username: query.get('username'),
        image: query.get('image'),
      };
      if (tUser?.image) {
        tUser.image = atob(tUser.image);
      }

      if (tUser?.userId) {
        setTargetUser(tUser);
      }
    }
  }, []);


  // -- API REQUESTS --//
  async function postVoucher(data) {

    setIsConfirmOpen(false);

    const voucherBody = {
      name: data?.name ? [data?.name] : [], // [String]
      description: data?.description ? [data?.description] : [], // [String]
      amount: data?.amount ? [parseFloat(data?.amount)] : [], // [Float]
      count: data?.count ? [parseInt(data?.count)] : [], // [Int]
      expireDate: data?.expireDate
        ? enifyDateTime(data?.expireDate?.format('jYYYY/jMM/jDD'))
        : null, // String
      currencyCode: 'IRR',
      limitedConsumerId: targetUser?.userId ?? null, // Int
    };

    let dataCartable = {
      "typeCode": 'MULTI_CONFIRMATION_TYPE_VOUCHER',
      "offset": '0',
      "size": '10'
    }
    if (isFromWallet) { // منوی دیجیتال است است
      voucherBody.wallet = data?.wallet?.code ?? `${null}`;
      dataCartable.wallet = data?.wallet?.code ?? `${null}`;
    } else { // منهوی تفصیلی است
      voucherBody.guildCode = data?.guildCode?.code ?? `${null}`;
      dataCartable.guildCode = data?.guildCode?.code ?? `${null}`;
    }


    setLoading(true);
    try {

      const cartableList = await CreateDiscountServices.getCarTableList(dataCartable);
      let res = null;
      if (cartableList?.result?.length > 0 && cartableList?.result[0]?.multiConfirmationSrv?.enable && !cartableList?.result[0]?.multiConfirmationSrv?.left) { // کارتابلی است
        voucherBody['cartableId'] = cartableList?.result[0]?.multiConfirmationSrv?.id
        isFromWallet && (voucherBody['wallet'] = data?.wallet?.code) // اگه دیجیتال باشه ، فیلد ولت رو براش ارسال میکنیم
        !isFromWallet && (voucherBody['guildCode'] = data?.guildCode?.code) // اگر تفصیلی باشه براش گلید کد رو میفرستیم
        res = await CreateDiscountServices.getCarTableCredit(voucherBody);
        setRequestId(res?.result?.id);
        setIsOpenMessageCartableDg(true);
      } else { // غیر کارتابلی است
        res = await CreateDiscountServices.postCreditVoucher(voucherBody);
        setGeneratedVouchers(res?.result);
        setTotalCount(voucherBody?.count);
        reformExportData(res?.result );
        setActiveStep(1);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }

  // -- OTHER FUNCTIONS --//
  const reformExportData = (vouchers ) => {
    const keysToMap = [
      { t: 'شماره', k: 'id', f: null },
      { t: 'کد بن', k: 'hash', f: null },
      {
        t: `مبلغ بن شارژ - ${currencyText}`,
        k: 'creditAmount',
        f: null,
      },
      {
        t: 'تاریخ انقضا',
        k: 'expireDate',
        f: (v) => enifyDateTime(jMoment(v).format('jYYYY/jM/jD HH:mm:ss')),
      },
    ];

    const titles = keysToMap.map((v) => v?.t);

    const data = vouchers.map((v, k) =>
      keysToMap.map((item) => (v[item?.k] ? (item?.f ? item.f(v[item?.k]) : v[item?.k]) : '-')),
    );

    setTitlesToExport(titles);
    setDataToExport(data);
  };

  const submitForm = (data) => {
    if (data && data?.amount && String(data?.amount) == '0') { // 
      createToast('خطا', 'مبلغ بن شارژ اشتباه است.', 'danger')
      return;
    }
    if (data && data?.count && String(data?.count) == '0') { // 
      createToast('خطا', 'تعداد بن شارژ قابل صدور اشتباه است.', 'danger')
      return;
    }
    setIsConfirmOpen(true)
  }


  const hint =
    'شما در این بخش می‌توانید یک بن به منظور شارژ موجودی حساب دیجیتال تعریف نمایید. همچنین امکان تعریف زمان اعتبار و محدودیت روی حساب تفصیلی قابل استفاده نیز وجود دارد.';

  return (
    <PageContainer subTitle={hint} title="ایجاد بن شارژ" breadcrumbs={constBreadCrumbsTitle.VOUCHER_ADD_CREDIT_VOUCHER}>
      {targetUser?.userId && activeStep !== 1 ? (
        <Grid container>
          <Grid xs={6} item>
            <Paper className={classes.targetUser}>
              <Typography className={classes.targetTitle}>تخصیص بن شارژ به کاربر</Typography>
              <Grid container className={classes.targetContainer}>
                <Grid item>
                  <img
                    alt={targetUser?.fullName ?? 'پروفایل کاربر'}
                    src={targetUser?.image ?? './images/profile.png'}
                    className={classes.profileImage}
                  />
                </Grid>
                <Grid item>
                  <Typography className={classes.targetFullName}>
                    {urlQuery?.isReport === 'true' ? (urlQuery?.firstName + ' ' + urlQuery?.lastName) : targetUser?.fullName ? targetUser?.fullName : '-'}

                  </Typography>
                  {urlQuery?.isReport !== 'true' && (
                    <Typography className={classes.targetUsername}>
                      {targetUser?.username ?? '-'}
                    </Typography>
                  )}
                  <Typography className={classes.targetId}>
                    شناسه کاربر :‌ {` ${targetUser?.userId}` ?? '-'}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      ) : null}
      {
        ((actionsList['creditVoucherList'] || actionsList['AddCreditVouchersBtn'] || actionsList['AddCreditVouchersSecoundBtn']) || (actionsList['AddCreditVouchersPage'])) &&

        <FormProvider {...methods}>
          <form
            onSubmit={handleSubmit(submitForm)}
            noValidate autoComplete="off">
            <StepperKeeperOld
              titles={[
                { label: 'اطلاعات پایه' },
                { label: 'دریافت بن‌های شارژ' },
              ]}
              onStepChanged={activeStep !== 1 ? setActiveStep : () => { }}
              forceSelectedTabIndex={activeStep}
              stepsToHideNext={[0]}
              stepsToHidePrevious={[1]}
              unreachableIndexes={[1]}

              panels={[
                <BaseInfo isFromWallet={isFromWallet} setIsFromWallet={setIsFromWallet} />,
                ((actionsList['creditVoucherList'] || actionsList['AddCreditVouchersBtn'] || actionsList['AddCreditVouchersSecoundBtn']) || (actionsList['AddCreditVouchersPage'])) && (
                  <GeneratedCodes
                    codes={generatedVouchers}
                    totalCount={totalCount}
                    user={targetUser}
                  />)
              ]}
              formAction={
                activeStep !== 1 ? (
                  <Grid container item xs={12} justifyContent="flex-end">
                    <div className={classes.containButton}>
                      {activeStep === 0 ? (
                        ((actionsList['creditVoucherList'] || actionsList['AddCreditVouchersBtn'] || actionsList['AddCreditVouchersSecoundBtn']) || (actionsList['AddCreditVouchersPage'])) && (
                          <ButtonLoading
                            variant="contained"
                            color="primary"
                            loading={loading}
                            name="ایجاد بن‌های شارژ"
                            type="submit"
                          />
                        )
                      ) : null}

                    </div>
                  </Grid>
                ) : (
                  <Grid container item xs={12} justifyContent="flex-end">
                    <div className={classes.containButton}>
                      <Button
                        variant="contained"
                        onClick={() => {
                          navigate('/CreditVoucher');
                        }}
                      >
                        بازگشت به لیست بن‌ها
                      </Button>
                    </div>
                  </Grid>
                )
              }
            />

            <ConfirmDialog
              open={isConfirmOpen}
              onClose={() => setIsConfirmOpen(false)}
              onConfirm={handleSubmit(postVoucher)}
              title="تایید ایجاد بن شارژ"
              confirmButtonText="ایجاد بن‌های شارژ"
              cancelButtonProps="انصراف"
            >
              <Overview
                data={methods.getValues()}
                targetUser={targetUser}
                isFromWallet={isFromWallet}
                currencyText={currencyText}
              />
            </ConfirmDialog>
          </form>
        </FormProvider>
      }
      <MessageCartableDg
        isOpenDg={isOpenMessageCartableDg}
        setIsOpenDg={setIsOpenMessageCartableDg}
        requestId={requestId}
        title='درخواست بن شارژ'
      />
    </PageContainer>
  );
};

export default CreateDiscount;
